export default __webpack_public_path__ + "static/media/diners.d4e68a74.svg";